import React from "react";
import "./styles.css";

const Chip = ({ label }) => <p className="chip">{label}</p>;

export default Chip;
